// src/utils/meoVat.js
//
// ============================================================
// 💡 SỔ TAY MẸO VẶT — những thứ không dính giao diện (Đợt N6, 15/09/2026)
// ------------------------------------------------------------
// Tách ra để THỬ ĐƯỢC (meoVat.test.js). Máy chủ kiểm lại y hệt ở
// quan-gia-api/meo-vat.js — kiểm ở đây chỉ để báo NGAY, khỏi chờ mạng.
// ============================================================

/**
 * MV3 — phân loại chọn từ danh sách. Lưu MÃ, hiện TÊN.
 * ⚠️ Thêm loại mới: thêm ở đây VÀ ở quan-gia-api/meo-vat.js.
 * ⚠️ Quá 10 loại phải báo anh Hùng trước (anh dặn: "có thể phình to, cảnh báo cho tôi").
 */
export const PHAN_LOAI = [
  { ma: "nau_an", ten: "🍳 Nấu ăn" },
  { ma: "nha_cua", ten: "🔧 Nhà cửa, sửa chữa" },
  { ma: "suc_khoe", ten: "🩹 Sức khoẻ" },
  { ma: "giat_giu", ten: "🧺 Giặt giũ, vệ sinh" },
  { ma: "con_cai", ten: "📚 Con cái, học hành" },
  { ma: "khac", ten: "📝 Khác" },
];

export const tenLoai = (ma) => (PHAN_LOAI.find((p) => p.ma === ma) || { ten: "📝 Khác" }).ten;

/** Biểu tượng đứng đầu tên loại — dùng làm ô ảnh nhỏ khi mẹo không có ảnh. */
export const bieuTuongLoai = (ma) => tenLoai(ma).split(" ")[0];

/** Bỏ dấu để tìm: gõ "vet dau" vẫn ra "vết dầu" (MV8). */
export const khongDau = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();

/** Tìm trong tiêu đề và nội dung, không phân biệt dấu, hoa thường. */
export const khopTim = (meo, tuTim) => {
  const t = khongDau((tuTim || "").trim());
  if (!t) return true;
  return khongDau(`${meo.tieu_de} ${meo.noi_dung || ""}`).includes(t);
};

/** MV6 — link bấm mở được phải là http:// hoặc https://. */
export const laLinkHopLe = (s) => /^https?:\/\/[^\s]+$/i.test(s || "");

/**
 * Đ3 — dòng "1. Khẩu phần…", "2. Nguyên liệu" tự in đậm (đầu mục của khung món
 * ăn). Chỉ số 1–2 chữ số + dấu chấm + khoảng trắng: "1.400.000 đ" KHÔNG đậm.
 */
export const laDauMuc = (dong) => /^\s*\d{1,2}\.\s+\S/.test(dong || "");

/**
 * Cắt một dòng chữ thành từng mẩu chữ thường / link, để link trong nội dung
 * bấm được. Dấu chấm, phẩy, ngoặc đóng dính cuối link thì trả về phần chữ.
 *   "Xem https://a.vn/x." → [{chu:"Xem "}, {link:"https://a.vn/x"}, {chu:"."}]
 */
export const tachLink = (dong) => {
  const ra = [];
  const mau = /https?:\/\/[^\s]+/gi;
  let cuoi = 0;
  let m;
  while ((m = mau.exec(dong)) !== null) {
    let link = m[0];
    const duoi = link.match(/[.,;:!?)\]]+$/);
    if (duoi) link = link.slice(0, -duoi[0].length);
    if (m.index > cuoi) ra.push({ chu: dong.slice(cuoi, m.index) });
    ra.push({ link });
    cuoi = m.index + link.length;
  }
  if (cuoi < dong.length) ra.push({ chu: dong.slice(cuoi) });
  return ra;
};

/**
 * Đ4 — khung món ăn 6 phần anh duyệt 15/09 (quan-gia-docs/mau-mon-an/KHUNG_MON_AN.md).
 * Bấm "📋 Dán khung món ăn" là ô nội dung có sẵn khung, chỉ việc điền.
 */
export const KHUNG_MON_AN = `1. Khẩu phần · thời gian
... người ăn · khoảng ... phút

2. Nguyên liệu (ghi rõ lượng: gam, trái, muỗng canh)
-
-

3. Sơ chế (xong hết mới bật bếp)
-

4. Các bước nấu
Bước 1 —
🔥 lửa ... · ⏱️ khoảng ... phút
👀 thấy ... là được

Bước 2 —
🔥 lửa ... · ⏱️ khoảng ... phút
👀 thấy ... là được

5. Thành phẩm (trông, ngửi, nếm ra sao)
-

6. Mẹo · lỗi hay gặp
- `;

/** Đ1 — số ngày lời khen nằm trên "Biết gì chưa?" (máy chủ quyết, đây chỉ để nói). */
export const NGAY_KHEN = 3;
